import { render } from "./badge-filter.vue?vue&type=template&id=2a90ff97"
import script from "./badge-filter.vue?vue&type=script&lang=js"
export * from "./badge-filter.vue?vue&type=script&lang=js"

import "./badge-filter.vue?vue&type=style&index=0&id=2a90ff97&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__